/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_ADMINISTRACAO_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodasPorProjeto(codUnidade, codProjeto) {
        return axiosJwt
            .get(`${api}/rm/acoes/${codUnidade}/${codProjeto}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
